import { MipTestAcceptabilitySummary, TestResults } from './../../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import { ParameterTypeName } from '../ParameterTypes';

export function MapMipTestAcceptabilitySummaries(testResults: TestResults[]): Array<MipTestAcceptabilitySummary> {
    return testResults.map(tr => {
        return {
            Accepted: tr.OverreaderAcceptability,
            TestId: tr.TestId,
            Mip: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_MIP).Value,
            Pip: tr.TestParameters.find(tp => tp.ParameterType == ParameterTypeName.PARAM_PIP).Value,
        } as MipTestAcceptabilitySummary;
    });
}


